
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import {AppError} from "@/plugins/axios";
  import {IRequestAuth} from "@/modules/Auth/interfaces/request-auth.interface";
  import OfertaPopup from "@/modules/Auth/components/OfertaPopup.vue"
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import moment from "moment";
  import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
  import LoginSelectCorpPopup from "@/modules/Auth/components/LoginSelectCorpPopup.vue";
  import {IProfile} from '@/modules/Profile/interfaces/profile.interface';
  import HomeLogo from "@/modules/Home/components/main/HomeLogo.vue";

  @Component({
    components: {
      HomeLogo,
      OfertaPopup,
      LoginSelectCorpPopup,
    }
  })
  export default class ThePageAuthorization extends Vue {
    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    doublePasswordForRecover = '';
    isHidePassword = false;
    login: string = this.$store.state.auth.login;
    password: string = this.$store.state.auth.password;
    isErrorLogin = false;
    animateLoginError = false;
    isErrorPassword = false;
    requestErrorText = '';
    displayPassword = false;
    refMode = false;

    resendPasswordTimeOut = 0;
    resendPasswordInterval = null;
    resendPasswordCount = 0;
    useSandedPassword = false;
    timeWaitByCount = [60, 60, 60, 60, 300, 300, 900];
    firstLogin = false;

    get dialogs(): IDialogStoreState { return this.$store.state.dialog; }
    get checkLogin() { return this.login; }
    get checkPassword() { return this.password; }
    get form(): any { return this.$refs['form']; }

    get formModel() {
      return {
        login: this.login,
        password: this.password
      };
    }

    get showMessage() { return this.$store.state.auth.isShowDialogSession; }
    set showMessage(value: boolean) { this.$store.dispatch('auth/setProperty', { name: 'isShowDialogSession', value }); }

    get recoverPassword () { return this.$store.state.auth.recoverPassword; }
    set recoverPassword (value: string) { this.doublePasswordForRecover = value; }

    get printedTimeRecover() {
      let minutes = Math.trunc((this.resendPasswordTimeOut - 1) / 60);
      let seconds = this.resendPasswordTimeOut % 60;
      let printedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      let printedSeconds = seconds < 10 ? `0${seconds}` : seconds;
      return `${printedMinutes}:${printedSeconds}`;
    }

    async created () {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('initialized');
      localStorage.setItem(IAuth.LocalStorageKeys.UseRecoverNow, 'false');

      let sometimeLoginCookie = Vue.cookie.get(IAuth.CookieName.UserSometimeLogin);
      if (sometimeLoginCookie) {
        this.firstLogin = !JSON.parse(sometimeLoginCookie);
      }
      else {
        this.firstLogin = true;
      }
    }

    async mounted() {
      this.isHidePassword = false;

      this.resendPasswordCount = +localStorage.getItem(IAuth.LocalStorageKeys.RecoverPasswordCount);
      let recoverTime = +localStorage.getItem(IAuth.LocalStorageKeys.RecoverPasswordTime);
      let recoverTimeout = +localStorage.getItem(IAuth.LocalStorageKeys.RecoverPasswordTimeout);
      if (recoverTime) {
        let currentTime = +moment().format('x');
        let diffTime = recoverTimeout - Math.trunc((currentTime - recoverTime) / 1000);

        if (diffTime > 0 && diffTime <= recoverTimeout) {
          this.resendPasswordTimeOut = diffTime;
          this.startRecoverTimer();
        }
      }

      await this.checkRefLogin();

      const { query } = this.$route;
      if (query.login) {
        this.login = query.login.toString();
      }
      if (query.from) {
        let url = '';
        switch (query.from.toString() ) {
          case 'pay':
            url = `${window.location.origin}${IApp.RoutePath[IApp.ROUTE_NAME.PAGE_PROFILE]}#${IProfile.PageTab.Payment}`;
            break;

          default:
            url = query.from.toString();
            break;
        }
        Vue.cookie.set(IAuth.CookieName.UrlForRedirectAfterLogin, url, {expires: '10Y'});
      }
    }

    onSubmit() {
      let that = this;
      this.requestErrorText = '';
      this.form.validate(async (valid) => {
        if (!valid) return false;

        if (!that.login) {
          that.isErrorLogin = true;
          that.activateLoginErrorAnimate();
          return false;
        }
        that.isErrorLogin = false;
        that.isErrorPassword = false;
        if(!!that.login) {
          that.$store.commit('auth/setLogin', that.login);
          that.$store.commit('auth/setPassword', that.password);
        }

        if (that.doublePasswordForRecover) {
          that.password = that.doublePasswordForRecover;
          that.$store.commit('auth/setPassword', that.password);
        }
        try {
          const response: any = await that.$store.dispatch('auth/login');
          if (response && response.userCorps) {
            return await this.$store.dispatch('dialog/openDialog', {
              blockName: 'auth',
              dialogName: 'loginSelectCorp',
              payload: {
                userCorps: response.userCorps
              },
            });
          }
          that.clearRecoverVariables();
        }
        catch (error) {
          if ((error as AppError).status === IRequestAuth.ErrorCode.InvalidLoginOrPassword) {
            this.requestErrorText = 'Сочетание логин-пароль не найдено.';
            this.$refs.passwordField.focus();
            return;
          }
          return await that.$store.dispatch('handleError', error);
        }
      });
    }

    clearRecoverVariables() {
      this.resendPasswordCount = 0;
      localStorage.setItem(IAuth.LocalStorageKeys.RecoverPasswordTimeout, '0');
      localStorage.setItem(IAuth.LocalStorageKeys.RecoverPasswordTime, '0');
    }

    async recoverPasswordAction() {
      if (!this.login) {
        this.isErrorLogin = true;
        this.activateLoginErrorAnimate();
        return;
      }

      let response = await this.$store.dispatch('auth/recoverPassword', this.login);

      if (response && response.success) {
        await this.checkRecoverPasswordCount();
      }

      let currentTime = moment().format('x');
      localStorage.setItem(IAuth.LocalStorageKeys.RecoverPasswordTime, currentTime.toString());

      this.$refs.passwordField.focus();
      this.useSandedPassword = true;
      this.resendPasswordCount++;

      let timeByCount = 0;
      let maxCount = this.timeWaitByCount.length;
      if (this.resendPasswordCount >= maxCount) timeByCount = this.timeWaitByCount[maxCount - 1];
      else timeByCount = this.timeWaitByCount[this.resendPasswordCount];
      this.resendPasswordTimeOut = response.success ? timeByCount - 1 : 3;

      localStorage.setItem(IAuth.LocalStorageKeys.RecoverPasswordTimeout, this.resendPasswordTimeOut.toString());
      this.startRecoverTimer();
    }

    startRecoverTimer() {
      let that = this;
      this.resendPasswordInterval = setInterval(() => {
        that.resendPasswordTimeOut--;
        if (!that.resendPasswordTimeOut) clearInterval(that.resendPasswordInterval);
      }, 1000);
    }

    /**
     * Проверка количества попыток восстановления пароля.
     * Если пароль восстанавливали больше двух раз подряд, то показываем сообщение.
     * Счетчик сбрасывает при 2 успешных авторизациях без использования восстановления.
     */
    async checkRecoverPasswordCount() {
      localStorage.setItem(IAuth.LocalStorageKeys.UseRecoverNow, 'true');
      localStorage.setItem(IAuth.LocalStorageKeys.SuccessLoginCount, '0');
      let recoverCount = +localStorage.getItem(IAuth.LocalStorageKeys.RecoverPasswordCount);
      if (recoverCount >= 2) {
        await this.$store.dispatch('confirm/open', {
          title: 'Внимание',
          text: `
            Для вашего удобства и безопасности рекомендуем сохранить полученный пароль в менеджере паролей браузера или запоминать его.<br>
            Вы можете изменить его в настройках профиля и использовать для последующих входов.`,
          cancel: { text: '', },
          confirm: { text: 'Ок', },
          class: 'recover-password-warning',
        });
      }
      recoverCount++;
      localStorage.setItem(IAuth.LocalStorageKeys.RecoverPasswordCount, recoverCount.toString());
    }

    activateLoginErrorAnimate() {
      this.animateLoginError = true;
      setTimeout(() => {
        this.animateLoginError = false;
      }, 1000);
    }

    async displayRegistNotice() {
      this.$notify({
        title: 'Внимание',
        message: 'Регистрация только через вашу управляющую компанию',
        type: 'warning'
      });
    }

    async goToRegistration() {
      await this.$store.dispatch('openPage', { routeName: ROUTE_NAME.PAGE_REGISTRATION });
    }

    async goToSupport() {
      await this.$store.dispatch('openPage', { routeName: ROUTE_NAME.PAGE_SUPPORT });
    }

    openPagePays() {
      this.$router.push({ name: ROUTE_NAME.PAGE_SCREEN_PAY });
    }

    async checkRefLogin() {
      const refCode = this.$route.query[ICorp.UrlGetParams.RefLink];
      if (refCode && refCode !== '') {
        this.refMode = true;
        this.login = refCode.toString();
        this.$store.commit('auth/setLogin', refCode);
        this.$store.commit('auth/setPassword', '');
        await this.$store.dispatch('auth/login');
      }
    }

    onPasswordInput() {
      this.$forceUpdate();
    }

    @Watch('recoverPassword')
    onRecoverPasswordChange () {
      if (this.recoverPassword) {
        this.password = this.recoverPassword;
        this.isHidePassword = true;
      }
    }

    @Watch('checkLogin')
    onLoginChange() {
      if (this.isErrorLogin && this.login) {
        this.isErrorLogin = false;
      }
    }

    @Watch('checkPassword')
    onPasswordChange() {
      if (this.isErrorPassword && this.password) {
        this.isErrorPassword = false;
      }
    }
  }
